module.exports = __webpack_public_path__ + "static/img/yanan.f9301b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/yanan.png
// module id = a65r
// module chunks = 1